<div *ngIf="irisModalRef?.config?.data?.isOpened == true">
    <p>
      {{irisModalRef?.config?.data?.bodyText}}
    </p>
    <iris-button-container [alignment]="buttonAlignmentOptions.END">
      <iris-button (click)="irisModalRef.close(true)">OK</iris-button>
    </iris-button-container>
</div>
